(() => {
  const roots = document.querySelectorAll('[data-az-origin-journey]');

  roots.forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[data-az-origin-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-az-origin-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;

    root.dataset.enhanced = 'true';

    const activate = (nextIndex, shouldFocus = false, updateHash = false) => {
      tabs.forEach((tab, index) => {
        const selected = index === nextIndex;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        panels[index].hidden = !selected;
      });

      if (shouldFocus) tabs[nextIndex].focus();
      if (updateHash && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', `#sastojak-${tabs[nextIndex].dataset.slug}`);
      }
    };

    let initialIndex = 0;
    const hash = window.location.hash.replace('#sastojak-', '');
    if (hash) {
      const hashIndex = tabs.findIndex((tab) => tab.dataset.slug === hash);
      if (hashIndex >= 0) initialIndex = hashIndex;
    }
    activate(initialIndex);

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activate(index, false, true);
      });

      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === index) return;
        event.preventDefault();
        activate(nextIndex, true, true);
      });
    });
  });
})();
